export const gKey = 'guilds';
export const dmKey = 'dms';
export const aKey = 'account';
export const fKey = 'friends';
export const rKey = 'requests';
export const nKey = 'notification';
export const cKey = 'channels';
export const mKey = 'members';
export const msgKey = 'messages';
export const vcKey = 'voice';
